export default "__VITE_ASSET__DtT0HmQt__"